<div class="p-grid">
	<div class="p-col">
		<span class="p-float-label mt-4">
			<p-dropdown
				#paymentEngineSelect
				[options]="paymentEngineOptions"
				optionLabel="label"
				optionValue="value"
				name="paymentEngineSelect"
				[(ngModel)]="onDevice.features.paymentEngine"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				(filterBy)="app.keys(paymentEngineOptions)"
				(onChange)="paymentEngineChange(); changesToSaveChange.emit(true)"
			></p-dropdown>
			<label for="paymentEngineSelect">Payment Engine</label>
		</span>
	</div>
	<div class="p-col">
		<span class="p-float-label mt-4">
			<p-dropdown
				#paymentInterfaceType
				[options]="paymentInterfaceOptions"
				optionLabel="label"
				optionValue="value"
				name="paymentInterfaceType"
				[(ngModel)]="onDevice.ip"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				itemSize="30"
				filter="true"
				(filterBy)="app.keys(paymentInterfaceOptions)"
				(onChange)="onInterfaceChange(); changesToSaveChange.emit(true)"
			></p-dropdown>
			<label for="paymentInterfaceType">Interface Type</label>
		</span>
	</div>
</div>
<div class="p-grid mt-2">
	<div class="p-col-12 p-md-6">
		<span class="p-float-label">
			<p-dropdown
				#paymentDeviceTypeSelect
				[options]="paymentEngineAvailableDevices"
				optionLabel="label"
				optionValue="value"
				name="paymentDeviceTypeSelect"
				[(ngModel)]="onDevice.sourceName"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				(filterBy)="app.keys(paymentEngineAvailableDevices)"
				(onChange)="selectDevice($event); changesToSaveChange.emit(true)"
			></p-dropdown>
			<label for="paymentDeviceType">Payment Device Type</label>
		</span>
	</div>
	<div class="p-col-12 p-md-6" *ngIf="onDevice.features.paymentEngine === 'ADYEN'">
		<span class="p-float-label">
			<p-dropdown
				*ngIf="focusPayDevicesGrouped && focusPayDevicesGrouped.length > 0"
				#focusPayDeviceListSelect
				[options]="focusPayDevicesGrouped"
				[group]="true"
				optionDisabled="disabled"
				name="focusPayDeviceListSelect"
				[(ngModel)]="onDevice.serialNumber"
				[style]="{ width: '100%' }"
				appendTo="body"
				(onChange)="onFocusPayDeviceSelect($event)"
			>
				<ng-template let-group pTemplate="group">
					<div class="flex align-items-center">
						<span>{{ group.label }}</span>
					</div>
				</ng-template>
			</p-dropdown>

			<label for="focusPayDeviceListSelect">Payment Device</label>
		</span>
	</div>
	<div class="p-col-12 p-md-6" *ngIf="onDevice.features.paymentEngine === 'DATACAP'">
		<span class="p-float-label">
			<span class="p-float-label">
				<input
					pInputText
					#secureDeviceIDInput
					name="secureDeviceIDInput"
					type="text"
					[(ngModel)]="onDevice.serialNumber"
					(ngModelChange)="changesToSaveChange.emit(true)"
					[disabled]="onDevice.features.paymentEngine === 'DATACAP'"
					class="w-100"
				/>
				<label for="secureDeviceIDInput">Pay Device Serial Number</label>
			</span>
		</span>
	</div>
</div>
<div class="p-grid" *ngIf="ethernetDevice">
	<div class="p-col-12 p-md-6 d-flex">
		<div class="my-auto">
			<div class="d-flex">
				<div class="my-auto">Set Payment Device IP Automatically</div>

				<p-inputSwitch
					[(ngModel)]="onDevice.features.updatePaymentDeviceIpAutomatically"
					styleClass="my-auto"
					(onChange)="changesToSaveChange.emit(true)"
				></p-inputSwitch>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6">
		<span class="p-float-label mt-4">
			<p-inputMask
				#paymentDeviceIpAddressInput
				[disabled]="onDevice.features.updatePaymentDeviceIpAutomatically"
				name="paymentDeviceIpAddressInput"
				[(ngModel)]="onDevice.ip"
				mask="999.999.999.999"
				styleClass="w-100"
				(ngModelChange)="changesToSaveChange.emit(true)"
			></p-inputMask>
			<label for="paymentDeviceIpAddressInput">Payment Device IP Address</label>
		</span>
	</div>
</div>
